import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Typography from "@material-ui/core/Typography";
import logo from "../../img/logo/logo_light.svg";
import clap_graph from "../../img/other/clap_graph.png";
import ItemsSummary from "./components/ItemDetail/ItemSummary";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { acceptTest } from "../../redux/actions/sagaActions";

const styles = theme => ({
  root: {
    flexGrow: 1
  },
  padding: {
    padding: 25
  },
  center: {
    textAlign: "center"
  }
});

class TestJoin extends React.PureComponent {
  render() {
    const { classes, tests, match, acceptTest } = this.props;
    const id = match.params.id;
    const item = tests[id] || null;

    return (
      <div className={classes.root}>
        <div className={classes.padding}>
          <Grid container spacing={32}>
            <Grid item xs={12} className={classes.center}>
              <img src={logo} style={{ maxHeight: 36 }} />
            </Grid>
          </Grid>
          <Grid container spacing={32}>
            <Grid item xs={12} className={classes.center}>
              <img src={clap_graph} />
            </Grid>
          </Grid>
          <Grid container spacing={32}>
            <Grid item xs={12} className={classes.center}>
              <Typography variant="display1" color="textPrimary">
                Perfecto Hombre !
              </Typography>
            </Grid>
          </Grid>
          <Grid container spacing={32}>
            <Grid item xs={1} className={classes.center} />
            <Grid item xs={10} className={classes.center}>
              <Typography variant="title">
                Hemos presentado tu solicitud en breve recibiras la
                confirmation.
              </Typography>
            </Grid>
            <Grid item xs={1} className={classes.center} />
          </Grid>
        </div>

        <ItemsSummary
          item={item}
          products={item.project.products}
          showStudyNumber={false}
          showHelpButton={false}
        />

        <div className={classes.padding}>
          <Typography paragraph>
            * Requerda que aun no estas inscrito definitivamente en el test.
            CosmoCare revisara tu solicitud y se pondra en contacto contigo para
            confirmar tu participation.
          </Typography>
        </div>

        <div className={classes.padding}>
          <Grid container spacing={32}>
            <Grid item xs={12} className={classes.center}>
              <Button
                variant="contained"
                color="primary"
                component={Link}
                to="/account/home?at=1"
                onClick={() => acceptTest({ id: item.id })}
              >
                Finalizar
              </Button>
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  tests: state.tests.invitations
});

export default withStyles(styles)(
  connect(
    mapStateToProps,
    { acceptTest }
  )(TestJoin)
);



// WEBPACK FOOTER //
// ./src/modules/test/TestJoin.js